import React, {useState} from 'react';
import {
  Button,
  useToaster,
  InputGroup,
  DateRangePicker,
  RadioTile,
  RadioTileGroup
} from 'rsuite';
import RebootConfirmationModal from "./RebootConfirmationModal";
import {TfiSave} from "react-icons/tfi";
import moment from "moment";
import {SharedApi} from "../../../../../../services/Shared.api";
import NotificationFactory from "../../../../../../shared/Notifications";

const DimmerWorkSection = ({
                             deviceId,
                             onModeChange,
                             loading,
                             timeScheduler,
                             duskDawnScheduler,
                             onTimeSchedulerChange,
                             schedulerMode,
                             onSaveTimeScheduler
                           }) => {
  const [showRebootModal, setShowRebootModal] = useState(false);
  const toaster = useToaster();
  const selectedMode = schedulerMode || 'Manual';

  const handleOpenRebootModal = () => {
    setShowRebootModal(true);
  };

  const handleCloseRebootModal = () => {
    setShowRebootModal(false);
  };

  const handleConfirmReboot = async () => {
    setShowRebootModal(false);
    try {
      const result = SharedApi.rebootDevice(deviceId)

      if (result) {
        toaster.push(
          NotificationFactory.success(),
          {placement: "topEnd"}
        );
      }
    } catch (error) {
      toaster.push(
        NotificationFactory.error(),
        {placement: "topEnd"}
      );
      console.error("Ошибка при перезапуске устройства:", error);
    }
  };

  const getDuskDawnSchedulerTime = () => {
    if (!duskDawnScheduler || duskDawnScheduler.length < 2) return '';
    return `${moment(duskDawnScheduler[0]).format('HH:mm')} - ${moment(duskDawnScheduler[1]).format('HH:mm')}`
  };

  const getTimeSchedulerText = () => {
    if (!timeScheduler || timeScheduler.length < 2) return '';
    return `${moment(timeScheduler[0]).format('HH:mm')} - ${moment(timeScheduler[1]).format('HH:mm')}`;
  };


  return (
    <>
      <section className="mt-3">
        <div className="row p-1">
          <div className="col-md-12">
            <RadioTileGroup
              aria-label="Режим работы"
              disabled={loading}
              name="work-group"
              value={selectedMode}
              onChange={(value) => onModeChange(value)}
            >
                <RadioTile
                  className="radio-tile"
                  value="Manual"
                  label="Ручной режим"
                >
                <span className="radio-tile-text">
                  Управление каналом вручную.
                </span>
                </RadioTile>

                <RadioTile
                  className="radio-tile"
                  value="Timer"
                  label={`По времени: ${getTimeSchedulerText()} `}
                >
                <span className="radio-tile-text">
                  Работа по расписанию по заданному времени.
                </span>
                </RadioTile>

                <RadioTile
                  className="radio-tile"
                  value="DuskDawn"
                  label={`Астрономическое реле: ${getDuskDawnSchedulerTime()} `}
                >
                <span className="radio-tile-text">
                  Управление в зависимости от времени восхода и заката.
                </span>
                </RadioTile>
            </RadioTileGroup>
          </div>
          <div className="col-md-12 mt-3">
            <InputGroup style={{marginBottom: '5px'}}>
              <InputGroup.Addon>По времени</InputGroup.Addon>
              <DateRangePicker
                value={timeScheduler}
                onChange={value => onTimeSchedulerChange(value)}
                style={{width: '100%'}}
                format="HH:mm"/>
              <InputGroup.Addon>
                <TfiSave
                  style={{cursor: 'pointer'}}
                  onClick={() => onSaveTimeScheduler(timeScheduler)}
                />
              </InputGroup.Addon>
            </InputGroup>
          </div>
          {/*<div className="col-md-12">*/}
          {/*  <InputGroup style={{marginBottom: '5px'}}>*/}
          {/*    <InputGroup.Addon>Восход - Закат</InputGroup.Addon>*/}
          {/*    <Input*/}
          {/*      value={getDuskDawnSchedulerTime()}*/}
          {/*      style={{width: '100%'}}*/}
          {/*    />*/}
          {/*  </InputGroup>*/}
          {/*</div>*/}
          <div className="col-md-12 text-center mt-3">
            <Button
              color="red"
              appearance="primary"
              type="button"
              onClick={handleOpenRebootModal}
              loading={loading}
              disabled={loading}
            >
              Перезапустить устройство
            </Button>
          </div>
        </div>
      </section>

      <RebootConfirmationModal
        show={showRebootModal}
        onHide={handleCloseRebootModal}
        onConfirm={handleConfirmReboot}
      />
    </>
  );
};

export default DimmerWorkSection;
